// Internal modules
import { apolloClient } from '../../apollo';
import { getToken } from '../../globals';
import { CHECKOUT_SESSION_QUERY } from '../queries';
import type { CheckoutSessionQueryQuery } from '@/generated/graphql';

export const queryCheckoutSession = (): Promise<
  CheckoutSessionQueryQuery['checkoutSession']
> => {
  /**
   * Why are we setting the `fetchPolicy` to `'network-only'`?
   *
   * This query only depends on a token, which won't change during the
   * transaction. If we don't set the `fetchPolicy` it will hit the cache
   * instead of making a network call. The issue is the content in the cache
   * won't match the new locale. This problem arises because when formatting
   * the data on the server then `req.locality` was used as the source of the
   * locale instead of adding a `locale` argument.
   */
  return apolloClient
    .query({
      context: {
        isBatchedQuery: true,
      },
      fetchPolicy: 'network-only',
      query: CHECKOUT_SESSION_QUERY,
      variables: {
        token: getToken(),
      },
    })
    .then(
      ({
        data,
      }: {
        data: { checkoutSession: CheckoutSessionQueryQuery['checkoutSession'] };
      }) => data.checkoutSession,
    );
};
